import React from 'react';
import { ZapIcon } from 'lucide-react';
import { painPoints } from '../data/content';
import { toneAt } from '../utils/iconTones';
export function ProblemSection() {
  return <section className="w-full bg-cream-100 px-6 py-14 sm:py-16" aria-labelledby="problema-titulo" data-id="element-145" data-mp="30h7mfrl9vyvm">
      <div className="mx-auto max-w-5xl text-center" data-id="element-146" data-mp="2vqhhugko801z">
        <h2 id="problema-titulo" className="mx-auto max-w-3xl font-display text-3xl font-bold leading-[1.15] text-forest-800 sm:text-4xl lg:text-[2.9rem]" data-id="element-147" data-mp="2vowmwpug2f3l">
          ¿Cuántas clases más vas a enseñar integración sin tener todo conectado?
        </h2>

        <p className="mx-auto mt-6 max-w-3xl text-base leading-relaxed text-forest-700/85 sm:text-lg" data-id="element-148" data-mp="3jf0q4w3q0cu2">
          Buscás cómo conectar el sensor con el PLC sin depender de hojas de datos dispersas. Y cuando un
          alumno pregunta cómo escalar una señal 4-20mA, implementar Modbus o qué es el mantenimiento
          predictivo, no tenés una respuesta clara basada en la realidad de planta.
        </p>

        <p className="mx-auto mt-6 flex max-w-2xl items-start justify-center gap-3 rounded-2xl bg-cream-200/70 px-6 py-4 text-base font-medium text-forest-800" data-id="element-149" data-mp="jeep0h5wp7fd">
          <ZapIcon className="mt-1 h-5 w-5 shrink-0 text-ember-500" aria-hidden="true" data-id="element-150" data-mp="se1sd8i74nb2" />
          <span data-id="element-151" data-mp="x4i6yvxr6ez0">
            No es falta de experiencia. Es que el material de integración industrial moderna no existe
            compilado en un solo ecosistema.
          </span>
        </p>

        <h3 className="mt-8 text-base font-medium text-forest-700/85" data-id="element-152" data-mp="172plz98hemyd">Esto quizás te está pasando hoy:</h3>

        <ul className="mt-5 grid gap-3 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-153" data-mp="1c226hnbvrhxs">
          {painPoints.map(({
          icon: Icon,
          title,
          description
        }, index) => <li key={title} className="flex h-full flex-col rounded-xl border border-cream-300/70 bg-cream-50 p-4 transition-[transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:shadow-card" data-id="element-154" data-mp="1g2l27sgw9859" data-mpi={index}>
              <div className="flex items-center gap-2.5" data-id="element-155" data-mp="ozqw25y4zlv0">
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg ${toneAt(index).bg}`} data-id="element-156" data-mp="p2d4e7suq5ea">
                  <Icon className={`h-3.5 w-3.5 ${toneAt(index).fg}`} aria-hidden="true" data-id="element-157" data-mp="y204mq9uh55r" />
                </span>
                <h4 className="text-sm font-semibold leading-tight text-forest-800" data-id="element-158" data-mp="tykd28cmtuzx">{title}</h4>
              </div>
              <p className="mt-2.5 text-[0.8rem] leading-relaxed text-forest-700/85" data-id="element-159" data-mp="17xa8ljjszmm6">{description}</p>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl font-display text-xl font-semibold italic leading-snug text-forest-700 sm:text-2xl" data-id="element-160" data-mp="1hood65qm3cm6">
          ¿Y si esta fuera la última semana que enseñás integración sin tener el sistema completo?
        </p>
      </div>
    </section>;
}